import { useState, useContext, useEffect, useMemo } from 'react'
import { PassContext } from '../pass-context'
import _ from "lodash"

import { TextField, Typography, Button, Tooltip } from '@mui/material'
import EastRoundedIcon from '@mui/icons-material/EastRounded'
import PopupShell from '../popup-shell'

const PopupDialogText = ({ open, close, title }) => {

  const { variables, setVariables } = useContext(PassContext)

  const [newVariables, setNewVariables] = useState({})

  const dataChanged = useMemo(() => {
    if (open) {
      if (!_.isEqual(variables, newVariables)) return true
    }

    return false
  }, [newVariables])

  // Runs on "open" state change or if template / variables change 
  // Ensures we have the current data rather than something left behind from previous form 
  useEffect(() => {
    try {
      if (open) {
        setNewVariables(_.cloneDeep(variables))
      }
    }
    catch (err) {
      throw err
    }
  }, [open,variables])


  //////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Support Functions
  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  const updateVariable = (field,value) => {
    setNewVariables(prev => {
      const newv = {...prev}
      _.set(newv,field,value)
      return newv
    })
  }

  const saveFormData = () => {
    if (!_.isEqual(newVariables,variables)) setVariables(newVariables)
    close()
  }

  const handleClose = (e, reason) => {
    if (reason && reason === "backdropClick")
      return
    close()
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Main Render
  //////////////////////////////////////////////////////////////////////////////////////////////////////////

    return (
      <PopupShell open={open} onClose={handleClose}>

        <div className="flex flex-col p-5 h-full">

          <div className="flex flex-row justify-between mt-5">
            <Typography color="secondary" variant="h6">{title}</Typography>
            <Tooltip title="You can press ESC on your keyboard to dismiss"><Button endIcon={<EastRoundedIcon />} onClick={handleClose} >cancel</Button></Tooltip>
          </div>

          <hr />
          <div className='mt-5 overflow-y-scroll flex flex-col gap-5 mb-[100px]'>

            <div className='mb-5'>You must either provide both a name and an address.</div>

            <TextField label="Venue Name"
              value={newVariables.event?.venue.name ?? ""}
              slotProps={{ inputLabel: { shrink: true } }}
              type="search"
              required={true}
              onChange={e => { updateVariable("event.venue.name",e.target.value) }}
              error={!newVariables.event?.venue.name}
            />

            <TextField label="Venue Address"
              value={newVariables.event?.venue.address ?? ""}
              slotProps={{ inputLabel: { shrink: true } }}
              type="search"
              onChange={e => { updateVariable("event.venue.address",e.target.value) }}
              required={true}
              multiline
              minRows={5}
              error={!newVariables.event?.venue.address}
            />

          </div>

          <div className='fixed bottom-5 w-[460px]'>
            <hr className='mb-5' />
            <div className="flex flex-row gap-5 justify-end">
              <Button variant="contained" disabled={!dataChanged} onClick={saveFormData}>Save</Button>
            </div>
          </div>

        </div>
      </PopupShell>
    )

}

export default PopupDialogText
